import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const AddonsTuorqouise = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      clipRule="evenodd"
      d="M12 13.433v5.973l-4.001 2.322a1.988 1.988 0 0 1-1.998 0l-3-1.741A2.015 2.015 0 0 1 2 18.244v-3.649c0-.72.382-1.384 1.001-1.742L7 10.532l5 2.901Z"
      fill="#55CEC3"
      fillRule="evenodd"
      opacity={0.8}
    />
    <path
      clipRule="evenodd"
      d="M22 14.595v3.65c0 .718-.382 1.383-1.001 1.741l-3 1.742a1.992 1.992 0 0 1-1.998 0L12 19.406v-5.972l5-2.902 3.999 2.321A2.012 2.012 0 0 1 22 14.595"
      fill="#55CEC3"
      fillRule="evenodd"
      opacity={0.5}
    />
    <path
      clipRule="evenodd"
      d="M17 5.753v4.779l-5 2.902-5-2.902v-4.78c0-.718.382-1.383 1.001-1.741l3-1.742a1.992 1.992 0 0 1 1.998 0l3 1.742A2.012 2.012 0 0 1 17 5.753"
      fill="#55CEC3"
      fillRule="evenodd"
    />
  </Icon>
));

export default AddonsTuorqouise;
